<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  score: { type: [Number, String], default: null },
});

const normalizedScore = computed(() => {
  if (props.score === null || props.score === undefined || props.score === '') {
    return null;
  }

  const numericScore = Number(props.score);
  if (!Number.isFinite(numericScore)) return null;

  return Math.round(Math.min(100, Math.max(0, numericScore)));
});

const activeHouses = computed(() => {
  if (normalizedScore.value === null || normalizedScore.value === 0) return 0;
  return Math.ceil(normalizedScore.value / 20);
});

const accessibleLabel = computed(() => {
  if (normalizedScore.value === null) return '';

  return `Potencial estimado por IA: ${normalizedScore.value} de 100, ${activeHouses.value} de 5 casas. Es una señal orientativa y no confirma una venta.`;
});
</script>

<template>
  <span
    v-show="normalizedScore !== null"
    v-tooltip.top="{
      content: accessibleLabel,
      delay: { show: 300, hide: 0 },
    }"
    class="inline-flex items-center justify-end gap-px h-2"
    role="img"
    :aria-label="accessibleLabel"
    data-testid="c21-sale-potential"
  >
    <Icon
      v-for="house in 5"
      :key="house"
      icon="i-lucide-house"
      class="size-2"
      :class="
        house <= activeHouses ? 'text-[#beaf87] fill-current' : 'text-n-slate-6'
      "
    />
  </span>
</template>
